
export const polygonChain = {
    id: 137,
    name: 'Polygon',
    network: 'matic',
    nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
    rpcUrls: {
        default: {
            http: [process.env.REACT_APP_POLYGON_RPC]
        },
        public: {
            http: [process.env.REACT_APP_POLYGON_RPC]
        }
    },
    blockExplorers: {
        etherscan: {
            name: 'PolygonScan',
            url: 'https://polygonscan.com'
        },
        default: {
            name: 'PolygonScan',
            url: 'https://polygonscan.com'
        }
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 25770160
        }
    }
} as any;